import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaCheckCircle, FaClipboardCheck, FaUserCheck, FaQuestionCircle, FaSearchengin, FaGlobe } from "react-icons/fa";
import styles from "../QualityAssurance.module.css";

const QADashboard = () => {
    const navigate = useNavigate();
    const [statistics, setStatistics] = useState({
        batchesPendingValidation: 0,
        batchesPendingApproval: 0,
        openInquiries: 0
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadStatistics();
    }, []);

    const loadStatistics = async () => {
        try {
            setLoading(true);
            // TODO: Replace with actual API calls
            // const accessToken = await getBackendAccessToken();
            // const data = await qaService.getStatistics(accessToken);
            
            // Placeholder data
            setStatistics({
                batchesPendingValidation: 12,
                batchesPendingApproval: 8,
                openInquiries: 5
            });
        } catch (error) {
            console.error('Failed to load QA statistics:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.dashboard}>
            {/* Statistics Section */}
            <div className={styles.statsGrid}>
                <div className={styles.statCard}>
                    <h3>Batches Pending Validation</h3>
                    <div className={styles.statNumber}>{statistics.batchesPendingValidation}</div>
                    <div className={styles.statLabel}>Awaiting QC Review</div>
                </div>
                <div className={styles.statCard}>
                    <h3>Batches Pending Approval</h3>
                    <div className={styles.statNumber}>{statistics.batchesPendingApproval}</div>
                    <div className={styles.statLabel}>Final Approval Needed</div>
                </div>
                <div className={styles.statCard}>
                    <h3>Open Inquiries</h3>
                    <div className={styles.statNumber}>{statistics.openInquiries}</div>
                    <div className={styles.statLabel}>Requires Response</div>
                </div>
            </div>

            {/* QA Actions */}
            <div className={styles.quickActions}>
                <h3>QA Actions</h3>
                <div className={styles.actionGrid}>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/validate')}
                    >
                        <span className={`${styles.actionIcon} ${styles.validate}`}><FaCheckCircle /></span>
                        <span>Validate</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/approve')}
                    >
                        <span className={`${styles.actionIcon} ${styles.approve}`}><FaClipboardCheck /></span>
                        <span>Approve</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/analyst-capability')}
                    >
                        <span className={`${styles.actionIcon} ${styles.capability}`}><FaUserCheck /></span>
                        <span>Analyst Capability</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/inquiries')}
                    >
                        <span className={`${styles.actionIcon} ${styles.inquiries}`}><FaQuestionCircle /></span>
                        <span>Inquiries</span>
                    </button>
                </div>
            </div>

            {/* Audit Actions */}
            <div className={styles.quickActions}>
                <h3>Audit Actions</h3>
                <div className={styles.actionGrid}>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/internal-audit')}
                    >
                        <span className={`${styles.actionIcon} ${styles.internalAudit}`}><FaSearchengin /></span>
                        <span>Internal Audit</span>
                    </button>
                    <button 
                        className={styles.actionButton}
                        onClick={() => navigate('/quality-assurance/external-audit')}
                    >
                        <span className={`${styles.actionIcon} ${styles.externalAudit}`}><FaGlobe /></span>
                        <span>External Audit</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QADashboard;
